export const checkIsDeleteType = (key) => {
  return key === "Delete";
};
export const checkIsBackspaceType = (key) => {
  return key === "Backspace";
};
export const isSpaceAdded = (caretPosition, maskedSeparation) => {
  const modulo = caretPosition % (maskedSeparation + 1);
  return modulo === 0;
};
export const calculateNewCaret = (key, caretPosition, separationLength) => {
  let newCaretPosition = caretPosition;
  if (
    checkIsDeleteType(key) &&
    isSpaceAdded(newCaretPosition + 1, separationLength)
  ) {
    newCaretPosition += 1;
  } else if (
    !checkIsDeleteType(key) &&
    !checkIsBackspaceType(key) &&
    isSpaceAdded(newCaretPosition, separationLength)
  ) {
    newCaretPosition += 1;
  }
  return newCaretPosition;
};

export const maskSeparation = (
  value,
  maxLength,
  separationLength,
  separator,
  type
) => {
  let newValue = value;
  let filterRegex = /\s/g;
  let regexString = `(\\w{${separationLength}})(?=\\w)`;
  if (type === "tel" || type === "number") {
    filterRegex = /\D/g;
    regexString = `(\\d{${separationLength}})(?=\\d)`;
  }
  newValue = newValue.replace(filterRegex, "");
  if (newValue.length > maxLength) {
    newValue = newValue.slice(0, maxLength);
  }
  const regex = new RegExp(regexString, "g");
  newValue = newValue.replace(regex, `$1${separator}`);
  return newValue;
};
